import styles from "./StudentBirthdays.module.css";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";

const data = [
  {
    _id: "1",
    name: "Varun Sir",
    age: "03 yrs",
    birthdate: "24 July",
    upcomingIn: "10 days",
  },
  {
    _id: "2",
    name: "Varun Sir",
    age: "03 yrs",
    birthdate: "24 July",
    upcomingIn: "10 days",
  },
  {
    _id: "3",
    name: "Varun Sir",
    age: "03 yrs",
    birthdate: "24 July",
    upcomingIn: "10 days",
  },
  {
    _id: "4",
    name: "Varun Sir",
    age: "03 yrs",
    birthdate: "24 July",
    upcomingIn: "10 days",
  },
];
  

function StudentBirthdays() {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const getColumnData = (data) => {
    return data.map((item) => ({
      name: <div className={styles.nameCell}>{item.name}</div>,
      age: <div className={styles.ageCell}>{item.age}</div>,
      birthdate: (
        <div className={styles.birthdateCell}>
          {item.birthdate}
          <span className={styles.upcomingText}>
            &nbsp;Upcoming in {item.upcomingIn}
          </span>
        </div>
      ),
    }));
  };
  

  const displayData = getColumnData(data);

  const headingsData = [
    { title: "Name", accessor: "name" },
    { title: "Age", accessor: "age" },
    { title: "Birthdate", accessor: "birthdate" },
  ];
  

  return (
    <div className={styles.headerContainer}>
      <div className={styles.totalstudentcard}>
        <div className={styles.studentsection}>
          <div className={styles.search}>
            <SearchBar
              placeholder="Search name"
              onChange={(e) => console.log(e.target.value)}
            />
          </div>
          <div className={styles.filters}>
            <Dropdown
              label="Status"
              options={["Recurring", "One-time"]}
              bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
            />
            <Dropdown
              label="Rooms"
              options={["Recurring", "One-time"]}
              bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
            />
            <Dropdown
              label="Upcoming"
              options={["Recurring", "One-time"]}
              bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
            />
          </div>
        </div>

        <div className={styles.dynamicdata}>
          <Dynamic
            headings={headingsData}
            columnData={displayData.slice(
              (currentPage - 1) * itemsPerPage,
              currentPage * itemsPerPage
            )}
          />
        </div>
        <div className={styles.paginationTable}>
          <PaginationTable
            data={displayData}
            currentPage={currentPage}
            itemsPerPage={itemsPerPage}
            setCurrentPage={setCurrentPage}
            setItemsPerPage={setItemsPerPage}
          />
        </div>
      </div>
    </div>
  );
}

export default StudentBirthdays;
